const projects = [
  {
    id: 0,
    title: "Daily Planner",
    description: "This was one of my first projects. I created an interactive Daily Planner. This project allows users to edit and save their schedule so when they return to the site they still have access their schedule.",
    image: {
      // name: "cal.jpg",
      alt: "daily planner application"
    },
    github:"https://github.com/tnj415/DailyPlanner",
    deploy: "https://tnj415.github.io/DailyPlanner/"
  },
  {
    id: 1,
    title: "Password Generator",
    description: "I created a simple, yet effective program that prompts the user for what type of password they want, then it generates a randomized password. I used JavaScript, CSS, and HTML.",
    image: {
      //name: "pwGen.PNG",
      alt: "password generator application"
    },
    github: "https://github.com/tnj415/PasswordGenerator",
    deploy: "https://tnj415.github.io/PasswordGenerator/"
  },
  {
    id: 2,
    title: "Music Searcher",
    description: "My first team project is this Music Searcher. Users can find information about an artist and new similar artists",
    image: {
      //name: "mms.PNG",
      alt: "music search website"
    },
    github: "https://github.com/apal96/magnificent-music-search",
    deploy: "https://apal96.github.io/magnificent-music-search/"
  },
  {
    id: 3,
    title: "Quiz Game",
    description: "This is a fun interactive game has a classic composition notebook theme. Users are quizzed on their knowledge of coding. A leader board displays high scores depending on the game mode. I used JavaScript, CSS, and HTML to create it.",
    image: {
      //name: "quiz.PNG",
      alt: "quiz game website"
    },
    github: "https://github.com/tnj415/QuizGame",
    deploy: "https://tnj415.github.io/QuizGame/"
  },
  {
    id: 4,
    title: "Weather Application",
    description: "This was created to provide users with access to weather conditions of the current day, as well as a 5 day forecast. It has a modern and simple layout to provide an intuitive user experience. I used JavaScript, CSS, and HTML to create it",
    image: {
      //name: "wyw.PNG",
      alt: "weather application"
    },
    github: "https://github.com/tnj415/WhatsYoWeather",
    deploy: "https://tnj415.github.io/WhatsYoWeather/"
  },
  {
    id: 5,
    title: "Event Architect",
    description: "I worked with a team to create this App that allows users to plan and join events. Login is required to join plan and edit events. Search for events using List.js and Browserify. We also used Node.js, Express, and MySql among other technologies",
    image: {
      //name: "e-a_demo.gif",
      alt: "ea app"
    },
    github: "tbd",
    deploy: "tbd"
  }
]

export default projects;
